export default "__VITE_ASSET__d3070ae5__"